var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AdminContractDetailList',{attrs:{"contract":_vm.contract,"lockedFilters":_vm.lockedFilters}})}
var staticRenderFns = []

export { render, staticRenderFns }